import { render } from "./Message.vue?vue&type=template&id=6479acc8"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=6479acc8&lang=css"
script.render = render

export default script